@if (!mobileModalPathActive()) {
  <app-dropdown
    #dropdownRef
    [componentWithDataSetter]="contentSetter"
    [widthInPX]="'600px'"
    [minWidthInPX]="'320px'"
    [dropdownListXPosition]="'right'"
    [dropdownListYPosition]="'remain_at_bottom'"
    [topThreshold]="useBasicInputTrigger() ? 32 : 0"
  >
    @if (useBasicInputTrigger()) {
      <div
        class="tw-w-full tw-cursor-pointer"
        (click)="$event.stopPropagation(); openPickerFromTrigger($event)"
      >
        <basic-input
          class="tw-w-full"
          [control]="displayControlForBasicInput"
          [label]="basicInputLabel()"
          [placeholder]="basicInputPlaceholder()"
          [id]="basicInputId()"
          [required]="basicInputRequired()"
          [readOnly]="true"
          [allowClearButton]="false"
          [icon]="calendarTriggerIcon"
          [fieldType]="fieldType()"
          (onFocusInput)="openPickerFromTrigger($event)"
        />
      </div>
    } @else {
      <div
        class="tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-cursor-pointer tw-p-1 tw-rounded-md hover:tw-bg-gray-200 tw-transition-colors"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 16.2C0 16.6774 0.189642 17.1352 0.527208 17.4728C0.864773 17.8104 1.32261 18 1.8 18H16.2C16.6774 18 17.1352 17.8104 17.4728 17.4728C17.8104 17.1352 18 16.6774 18 16.2V7.2H0V16.2ZM12.6 9.45C12.6 9.33065 12.6474 9.21619 12.7318 9.1318C12.8162 9.04741 12.9307 9 13.05 9H13.95C14.0693 9 14.1838 9.04741 14.2682 9.1318C14.3526 9.21619 14.4 9.33065 14.4 9.45V10.35C14.4 10.4693 14.3526 10.5838 14.2682 10.6682C14.1838 10.7526 14.0693 10.8 13.95 10.8H13.05C12.9307 10.8 12.8162 10.7526 12.7318 10.6682C12.6474 10.5838 12.6 10.4693 12.6 10.35V9.45ZM12.6 13.05C12.6 12.9307 12.6474 12.8162 12.7318 12.7318C12.8162 12.6474 12.9307 12.6 13.05 12.6H13.95C14.0693 12.6 14.1838 12.6474 14.2682 12.7318C14.3526 12.8162 14.4 12.9307 14.4 13.05V13.95C14.4 14.0693 14.3526 14.1838 14.2682 14.2682C14.1838 14.3526 14.0693 14.4 13.95 14.4H13.05C12.9307 14.4 12.8162 14.3526 12.7318 14.2682C12.6474 14.1838 12.6 14.0693 12.6 13.95V13.05ZM8.1 9.45C8.1 9.33065 8.14741 9.21619 8.2318 9.1318C8.31619 9.04741 8.43065 9 8.55 9H9.45C9.56935 9 9.68381 9.04741 9.7682 9.1318C9.85259 9.21619 9.9 9.33065 9.9 9.45V10.35C9.9 10.4693 9.85259 10.5838 9.7682 10.6682C9.68381 10.7526 9.56935 10.8 9.45 10.8H8.55C8.43065 10.8 8.31619 10.7526 8.2318 10.6682C8.14741 10.5838 8.1 10.4693 8.1 10.35V9.45ZM8.1 13.05C8.1 12.9307 8.14741 12.8162 8.2318 12.7318C8.31619 12.6474 8.43065 12.6 8.55 12.6H9.45C9.56935 12.6 9.68381 12.6474 9.7682 12.7318C9.85259 12.8162 9.9 12.9307 9.9 13.05V13.95C9.9 14.0693 9.85259 14.1838 9.7682 14.2682C9.68381 14.3526 9.56935 14.4 9.45 14.4H8.55C8.43065 14.4 8.31619 14.3526 8.2318 14.2682C8.14741 14.1838 8.1 14.0693 8.1 13.95V13.05ZM3.6 9.45C3.6 9.33065 3.64741 9.21619 3.7318 9.1318C3.81619 9.04741 3.93065 9 4.05 9H4.95C5.06935 9 5.18381 9.04741 5.2682 9.1318C5.35259 9.21619 5.4 9.33065 5.4 9.45V10.35C5.4 10.4693 5.35259 10.5838 5.2682 10.6682C5.18381 10.7526 5.06935 10.8 4.95 10.8H4.05C3.93065 10.8 3.81619 10.7526 3.7318 10.6682C3.64741 10.5838 3.6 10.4693 3.6 10.35V9.45ZM3.6 13.05C3.6 12.9307 3.64741 12.8162 3.7318 12.7318C3.81619 12.6474 3.93065 12.6 4.05 12.6H4.95C5.06935 12.6 5.18381 12.6474 5.2682 12.7318C5.35259 12.8162 5.4 12.9307 5.4 13.05V13.95C5.4 14.0693 5.35259 14.1838 5.2682 14.2682C5.18381 14.3526 5.06935 14.4 4.95 14.4H4.05C3.93065 14.4 3.81619 14.3526 3.7318 14.2682C3.64741 14.1838 3.6 14.0693 3.6 13.95V13.05Z"
            fill="#111928"
          />
          <path
            d="M18 3.6C18 3.12261 17.8104 2.66477 17.4728 2.32721C17.1352 1.98964 16.6774 1.8 16.2 1.8H14.4V0.9C14.4 0.661305 14.3052 0.432387 14.1364 0.263604C13.9676 0.0948211 13.7387 0 13.5 0C13.2613 0 13.0324 0.0948211 12.8636 0.263604C12.6948 0.432387 12.6 0.661305 12.6 0.9V1.8H9.9V0.9C9.9 0.661305 9.80518 0.432387 9.6364 0.263604C9.46761 0.0948211 9.23869 0 9 0C8.7613 0 8.53239 0.0948211 8.3636 0.263604C8.19482 0.432387 8.1 0.661305 8.1 0.9V1.8H5.4V0.9C5.4 0.661305 5.30518 0.432387 5.1364 0.263604C4.96761 0.0948211 4.73869 0 4.5 0C4.26131 0 4.03239 0.0948211 3.8636 0.263604C3.69482 0.432387 3.6 0.661305 3.6 0.9V1.8H1.8C1.32261 1.8 0.864773 1.98964 0.527208 2.32721C0.189642 2.66477 0 3.12261 0 3.6V5.4H18V3.6Z"
            fill="#111928"
          />
        </svg>

        <span class="tw-text-gray-900 tw-text-sm md:tw-text-base tw-font-inter tw-min-w-0 tw-flex tw-items-center tw-gap-1.5 tw-truncate">
          @if (startDate() == null || startDate() === '') {
            None selected
          } @else {
            <span class="tw-truncate">{{ formattedStartForDisplay() }}</span>
            @if (isIndefiniteEndDisplay()) {
              <span class="tw-shrink-0 tw-text-gray-900" aria-hidden="true">-</span>
              <span
                class="tw-shrink-0 tw-inline-flex tw-items-center tw-text-gray-900"
                aria-label="No end date"
                [innerHTML]="indefiniteEndIconSvg | safe"
              ></span>
            } @else if (hasDistinctRangeEnd()) {
              <span class="tw-shrink-0 tw-text-gray-400" aria-hidden="true">-</span>
              <span class="tw-truncate">{{ formattedEndForDisplay() }}</span>
            }
          }
        </span>
      </div>
    }
  </app-dropdown>
} @else {
  @if (useBasicInputTrigger()) {
    <div
      class="tw-w-full tw-cursor-pointer"
      (click)="$event.stopPropagation(); openMobileModal($event)"
    >
      <basic-input
        class="tw-w-full"
        [control]="displayControlForBasicInput"
        [label]="basicInputLabel()"
        [placeholder]="basicInputPlaceholder()"
        [id]="basicInputId()"
        [required]="basicInputRequired()"
        [readOnly]="true"
        [allowClearButton]="false"
        [icon]="calendarTriggerIcon"
        [fieldType]="fieldType()"
        (onFocusInput)="openMobileModal($event)"
      />
    </div>
  } @else {
    <div
      class="tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-cursor-pointer tw-p-1 tw-rounded-md hover:tw-bg-gray-200 tw-transition-colors"
      (click)="openMobileModal($event)"
    >
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 16.2C0 16.6774 0.189642 17.1352 0.527208 17.4728C0.864773 17.8104 1.32261 18 1.8 18H16.2C16.6774 18 17.1352 17.8104 17.4728 17.4728C17.8104 17.1352 18 16.6774 18 16.2V7.2H0V16.2ZM12.6 9.45C12.6 9.33065 12.6474 9.21619 12.7318 9.1318C12.8162 9.04741 12.9307 9 13.05 9H13.95C14.0693 9 14.1838 9.04741 14.2682 9.1318C14.3526 9.21619 14.4 9.33065 14.4 9.45V10.35C14.4 10.4693 14.3526 10.5838 14.2682 10.6682C14.1838 10.7526 14.0693 10.8 13.95 10.8H13.05C12.9307 10.8 12.8162 10.7526 12.7318 10.6682C12.6474 10.5838 12.6 10.4693 12.6 10.35V9.45ZM12.6 13.05C12.6 12.9307 12.6474 12.8162 12.7318 12.7318C12.8162 12.6474 12.9307 12.6 13.05 12.6H13.95C14.0693 12.6 14.1838 12.6474 14.2682 12.7318C14.3526 12.8162 14.4 12.9307 14.4 13.05V13.95C14.4 14.0693 14.3526 14.1838 14.2682 14.2682C14.1838 14.3526 14.0693 14.4 13.95 14.4H13.05C12.9307 14.4 12.8162 14.3526 12.7318 14.2682C12.6474 14.1838 12.6 14.0693 12.6 13.95V13.05ZM8.1 9.45C8.1 9.33065 8.14741 9.21619 8.2318 9.1318C8.31619 9.04741 8.43065 9 8.55 9H9.45C9.56935 9 9.68381 9.04741 9.7682 9.1318C9.85259 9.21619 9.9 9.33065 9.9 9.45V10.35C9.9 10.4693 9.85259 10.5838 9.7682 10.6682C9.68381 10.7526 9.56935 10.8 9.45 10.8H8.55C8.43065 10.8 8.31619 10.7526 8.2318 10.6682C8.14741 10.5838 8.1 10.4693 8.1 10.35V9.45ZM8.1 13.05C8.1 12.9307 8.14741 12.8162 8.2318 12.7318C8.31619 12.6474 8.43065 12.6 8.55 12.6H9.45C9.56935 12.6 9.68381 12.6474 9.7682 12.7318C9.85259 12.8162 9.9 12.9307 9.9 13.05V13.95C9.9 14.0693 9.85259 14.1838 9.7682 14.2682C9.68381 14.3526 9.56935 14.4 9.45 14.4H8.55C8.43065 14.4 8.31619 14.3526 8.2318 14.2682C8.14741 14.1838 8.1 14.0693 8.1 13.95V13.05ZM3.6 9.45C3.6 9.33065 3.64741 9.21619 3.7318 9.1318C3.81619 9.04741 3.93065 9 4.05 9H4.95C5.06935 9 5.18381 9.04741 5.2682 9.1318C5.35259 9.21619 5.4 9.33065 5.4 9.45V10.35C5.4 10.4693 5.35259 10.5838 5.2682 10.6682C5.18381 10.7526 5.06935 10.8 4.95 10.8H4.05C3.93065 10.8 3.81619 10.7526 3.7318 10.6682C3.64741 10.5838 3.6 10.4693 3.6 10.35V9.45ZM3.6 13.05C3.6 12.9307 3.64741 12.8162 3.7318 12.7318C3.81619 12.6474 3.93065 12.6 4.05 12.6H4.95C5.06935 12.6 5.18381 12.6474 5.2682 12.7318C5.35259 12.8162 5.4 12.9307 5.4 13.05V13.95C5.4 14.0693 5.35259 14.1838 5.2682 14.2682C5.18381 14.3526 5.06935 14.4 4.95 14.4H4.05C3.93065 14.4 3.81619 14.3526 3.7318 14.2682C3.64741 14.1838 3.6 14.0693 3.6 13.95V13.05Z"
          fill="#111928"
        />
        <path
          d="M18 3.6C18 3.12261 17.8104 2.66477 17.4728 2.32721C17.1352 1.98964 16.6774 1.8 16.2 1.8H14.4V0.9C14.4 0.661305 14.3052 0.432387 14.1364 0.263604C13.9676 0.0948211 13.7387 0 13.5 0C13.2613 0 13.0324 0.0948211 12.8636 0.263604C12.6948 0.432387 12.6 0.661305 12.6 0.9V1.8H9.9V0.9C9.9 0.661305 9.80518 0.432387 9.6364 0.263604C9.46761 0.0948211 9.23869 0 9 0C8.7613 0 8.53239 0.0948211 8.3636 0.263604C8.19482 0.432387 8.1 0.661305 8.1 0.9V1.8H5.4V0.9C5.4 0.661305 5.30518 0.432387 5.1364 0.263604C4.96761 0.0948211 4.73869 0 4.5 0C4.26131 0 4.03239 0.0948211 3.8636 0.263604C3.69482 0.432387 3.6 0.661305 3.6 0.9V1.8H1.8C1.32261 1.8 0.864773 1.98964 0.527208 2.32721C0.189642 2.66477 0 3.12261 0 3.6V5.4H18V3.6Z"
          fill="#111928"
        />
      </svg>

      <span class="tw-text-gray-900 tw-text-sm md:tw-text-base tw-font-inter tw-min-w-0 tw-flex tw-items-center tw-gap-1.5 tw-truncate">
        @if (startDate() == null || startDate() === '') {
          None selected
        } @else {
          <span class="tw-truncate">{{ formattedStartForDisplay() }}</span>
          @if (isIndefiniteEndDisplay()) {
            <span class="tw-shrink-0 tw-text-gray-400" aria-hidden="true">-</span>
            <span
              class="tw-shrink-0 tw-inline-flex tw-items-center tw-text-gray-900"
              aria-label="No end date"
              [innerHTML]="indefiniteEndIconSvg | safe"
            ></span>
          } @else if (hasDistinctRangeEnd()) {
            <span class="tw-shrink-0 tw-text-gray-400" aria-hidden="true">-</span>
            <span class="tw-truncate">{{ formattedEndForDisplay() }}</span>
          }
        }
      </span>
    </div>
  }
}

@if (useModalOnMobile()) {
  <modal
    [id]="mobileModalId"
    [header]="mobileModalTitle()"
    [headerIcon]="mobileModalHeaderIcon"
    [showHeader]="true"
    [showHeaderDivider]="true"
    [showFooterDivider]="false"
    [heightClass]="'tw-h-auto'"
    [widthClass]="'event-dates-modal-shell--picker'"
    [enableBackdropClose]="true"
  >
    <div slot="body" class="tw--mx-2 tw--mt-1">
      <div class="tw-mb-4 tw-border-gray-100">
        <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-text-sm tw-font-inter">
          <div class="tw-min-w-0 tw-flex-1">
            <div class="tw-text-base tw-font-medium tw-text-gray-500">From</div>
            <div
              class="tw-truncate tw-text-sm tw-font-medium tw-text-gray-700"
              [class.tw-font-semibold]="!!startDate()"
              [class.tw-text-gray-900]="!!startDate()"
              [class.tw-text-gray-400]="!startDate()"
            >
              {{ modalSummaryStartText() }}
            </div>
          </div>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-shrink-0 tw-mt-1 tw-self-center">
            <path d="M15.913 6.45783C15.9995 6.23906 16.0222 5.99833 15.978 5.76609C15.9339 5.53386 15.8249 5.32055 15.665 5.15317L11.0933 0.365411C10.9878 0.251091 10.8617 0.159906 10.7223 0.0971757C10.5828 0.0344453 10.4329 0.00142624 10.2811 4.51929e-05C10.1294 -0.00133585 9.97885 0.0289485 9.83839 0.0891316C9.69793 0.149315 9.57032 0.238191 9.463 0.350575C9.35569 0.462959 9.27083 0.596599 9.21336 0.743699C9.15589 0.890798 9.12697 1.04841 9.12829 1.20734C9.12961 1.36627 9.16114 1.52333 9.22104 1.66936C9.28094 1.81539 9.36801 1.94747 9.47717 2.05788L12.0991 4.80366H1.14293C0.839806 4.80366 0.549097 4.92977 0.334756 5.15423C0.120416 5.3787 0 5.68315 0 6.0006C0 6.31805 0.120416 6.62249 0.334756 6.84696C0.549097 7.07143 0.839806 7.19754 1.14293 7.19754H12.0991L9.47831 9.94212C9.36915 10.0525 9.28208 10.1846 9.22218 10.3306C9.16228 10.4767 9.13075 10.6337 9.12943 10.7927C9.12811 10.9516 9.15703 11.1092 9.2145 11.2563C9.27197 11.4034 9.35683 11.537 9.46415 11.6494C9.57146 11.7618 9.69907 11.8507 9.83953 11.9109C9.97999 11.9711 10.1305 12.0013 10.2823 12C10.434 11.9986 10.584 11.9656 10.7234 11.9028C10.8629 11.8401 10.989 11.7489 11.0944 11.6346L15.6661 6.84683C15.772 6.7354 15.8559 6.60322 15.913 6.45783V6.45783Z" fill="#6B7280"/>
          </svg>
          <div class="tw-min-w-0 tw-flex-1 tw-text-left">
            <div class="tw-text-base tw-font-medium tw-text-gray-500">To</div>
            <div
              class="date-range-picker__footer-line tw-truncate tw-text-sm tw-font-medium tw-text-gray-700 tw-flex tw-justify-start tw-items-center"
              [class.tw-font-semibold]="summaryEndHasConcreteDate()"
              [class.tw-text-gray-900]="summaryEndHasConcreteDate()"
              [class.tw-text-gray-400]="!summaryEndHasConcreteDate()"
            >
              @if (isIndefiniteEndDisplay()) {
                <span
                  class="tw-inline-flex tw-items-center tw-text-gray-900"
                  aria-label="No end date"
                  role="img"
                  [innerHTML]="indefiniteEndIconSvg | safe"
                ></span>
              } @else {
                {{ modalSummaryEndText() }}
              }
            </div>
          </div>
        </div>
      </div>
      <div class="tw-rounded-xl tw-bg-gray-50 tw-border tw-border-gray-100 tw-overflow-hidden">
        <app-date-range-picker-content #modalPickerContent></app-date-range-picker-content>
      </div>
    </div>
  </modal>
}
